import React from 'react'
import styles from './profile-permission.styles'
import injectSheet from 'react-jss'
import ProfilePermissionHead from './profile-permission-head/profile-permission-head.container'

const ProfilePermission = ({ classes }) => {
  return (
    <div className={classes.container}>
      <ProfilePermissionHead />
    </div>
  )
}

export default injectSheet(styles)(ProfilePermission)
